import { render, staticRenderFns } from "./EditCommentModal.vue?vue&type=template&id=2cd1bff6&scoped=true"
import script from "./EditCommentModal.vue?vue&type=script&lang=ts"
export * from "./EditCommentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd1bff6",
  null
  
)

export default component.exports